import React from 'react';
import Section from '../Section';
import EntryClosedNotice from '../EntryClosedNotice';
import { CONTACT_EMAIL, ENTRY_ANCHOR_ID } from '../content';
import styles from './EntryForm.module.css';

// エントリー受付は 2026-09-07 に終了。HRMOS フォームは撤去し、終了告知のみ出す。
export default function EntryForm() {
  return (
    <Section id={ENTRY_ANCHOR_ID} title="エントリー" eyebrow="ENTRY">
      <EntryClosedNotice variant="form" />
      <div className={styles.contact}>
        <p className={styles.contactLabel}>お問い合わせはこちら</p>
        <a href={`mailto:${CONTACT_EMAIL}`} className={styles.contactLink}>
          {CONTACT_EMAIL}
        </a>
      </div>
    </Section>
  );
}
